<template>
  <page>
    <lazy-div>
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon v-if="newMode">mdi-plus</v-icon>
          <v-icon v-else-if="reviewMode">mdi-pencil</v-icon>
          <v-icon v-else-if="queryMode">mdi-magnify</v-icon>
          <v-toolbar-title v-if="newMode">Create Permitted NOL per Bus. Class</v-toolbar-title>
          <v-toolbar-title v-else-if="reviewMode">Edit Permitted NOL per Bus. Class</v-toolbar-title>
          <v-toolbar-title v-else-if="queryMode">Query Permitted NOL per Bus. Class</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <message :messages="messages"></message>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs6>
                <v-autocomplete
                  :readonly="reviewMode || queryMode"
                  :label="labels.busCls"
                  :items="busClsDropDownList"
                  v-model="form.busCls"
                  item-text="busClsWithDesc"
                  item-value="busCls"
                  data-vv-name="busCls"
                  :data-vv-as="labels.busCls"
                  :error-messages="errors.collect('busCls')"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  readonly
                  v-model="form.busClsDesc"
                  :label="labels.busClsDesc"
                  :error-messages="errors.collect('busClsDesc')"
                  data-vv-name="busClsDesc"
                  :data-vv-as="labels.busClsDesc"
                  v-validate="'max:40'"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6>
                <v-autocomplete
                  :readonly="reviewMode || queryMode"
                  :label="labels.nol1"
                  :items="clmNol1DropDownList"
                  v-model="form.nol1"
                  item-text="nol1WithLongDesc"
                  item-value="nol1"
                  data-vv-name="nol1"
                  :data-vv-as="labels.nol1"
                  :error-messages="errors.collect('nol1')"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  readonly
                  v-model="form.nol1longDesc"
                  :label="labels.nol1longDesc"
                  :error-messages="errors.collect('nol1longDesc')"
                  data-vv-name="nol1longDesc"
                  :data-vv-as="labels.nol1longDesc"
                  v-validate="'max:40'"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs6>
                <v-text-field
                  :readonly="queryMode"
                  v-model="form.giaType"
                  :label="labels.giaType"
                  :error-messages="errors.collect('giaType')"
                  data-vv-name="giaType"
                  :data-vv-as="labels.giaType"
                  v-validate="'max:2'"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.createdBy }}</v-subheader>
                <div class="queryValue">{{ createdBy }}</div>
              </v-flex>
              <v-flex xs6 v-if="!newMode">
                <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
                <div class="queryValue">{{ createdDate }}</div>
              </v-flex>
              <v-flex xs6 v-else>
                <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
                <div class="queryValue">{{ formatDisplayDate(createdDate) }}</div>
              </v-flex>
            </v-layout>
            <v-layout row wrap v-if="!newMode">
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.modifiedBy }}</v-subheader>
                <div class="queryValue">{{ modifiedBy }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
                <div class="queryValue">{{ modifiedDate }}</div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn color="red" dark class=" mr-2" @click="doCancel" :loading="submitting">
            Cancel
            <v-icon right>mdi-cancel</v-icon>
          </v-btn>
          <v-btn color="primary" v-if="newMode || reviewMode" dark class=" mr-2" @click="doSave" :loading="submitting">
            Save
            <v-icon right>mdi-content-save</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </lazy-div>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { formatDisplayDate } from '@/utils/date'
import { expandURI } from '@/utils/ajax'
export default {
  data() {
    return {
      labels: {
        busCls: 'Business Class',
        nol1: 'Nature Of Loss 1',
        busClsDesc: 'Description',
        nol1longDesc: 'Long Description',
        giaType: 'GIA Type',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date'
      },
      form: {
        busCls: '',
        nol1: '',
        busClsDesc: '',
        nol1longDesc: '',
        giaType: ''
      },
      createdBy: this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName,
      createdDate: new Date(),
      modifiedBy: '',
      modifiedDate: undefined,
      newMode: false,
      reviewMode: false,
      queryMode: false,
      loading: false,
      submitting: false,
      busClsDropDownList: [],
      clmNol1DropDownList: []
    }
  },
  methods: {
    formatDisplayDate(xDate) {
      return formatDisplayDate(xDate)
    },
    async doFetchBusClsDropDown() {
      const apiURI = this.menu.getBusClsDropDownList
      if (apiURI) {
        this.loading = true
        this.$http
          .get(apiURI)
          .then((result) => {
            this.busClsDropDownList = []
            const { data } = result.data
            if (data) {
              data.map((busClsMap) => {
                const convertBusClsList = {
                  busCls: busClsMap.busCls,
                  busClsDesc: busClsMap.desc,
                  busClsWithDesc: busClsMap.busCls + ' - ' + busClsMap.desc
                }
                this.busClsDropDownList.push(convertBusClsList)
              })
            }
            this.loading = false
          })
          .catch((err) => {
            this.loading = false
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      }
    },
    async doFetchClmNol1DropDown() {
      const apiURI = this.menu.getClmNOL1DropDownList
      if (apiURI) {
        this.loading = true
        this.$http
          .get(apiURI)
          .then((result) => {
            this.clmNol1DropDownList = []
            const { data } = result.data
            if (data) {
              data.map((nol1Map) => {
                const convertNol1List = {
                  nol1: nol1Map.nol1,
                  nol1longDesc: nol1Map.nol1LongDesc,
                  nol1WithLongDesc: nol1Map.nol1 + ' - ' + nol1Map.nol1LongDesc
                }
                this.clmNol1DropDownList.push(convertNol1List)
              })
            }
            this.loading = false
          })
          .catch((err) => {
            this.loading = false
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      }
    },
    async doFetchData() {
      const apiURI = this.menu.getBusClsClmNOL1
      if (apiURI) {
        this.loading = true
        try {
          const expand = { busCls: this.busClsParam, nol1: this.nol1Param }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.form.busCls = data.busClsClmNOL1.busCls
            this.form.busCLlsDesc = data.busClsClmNOL1.busClsDesc
            this.form.nol1 = data.busClsClmNOL1.nol1
            this.form.nol1longDesc = data.busClsClmNOL1.nol1longDesc
            this.form.giaType = data.busClsClmNOL1.giaType
            this.createdBy = data.createdBy
            this.createdDate = formatDisplayDate(data.createdDate)
            this.modifiedBy = data.modifiedBy
            this.modifiedDate = formatDisplayDate(data.modifiedDate)
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.loading = false
      }
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.newMode) {
            this.doCreate()
          } else if (this.reviewMode) {
            this.doUpdate()
          }
        }
      })
    },
    async doCreate() {
      const apiURI = this.menu.createPmtNOL1PerBusCls
      const form = this.form
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, form)
          const { data } = result
          if (data) {
            this.notify(data)
            this.message(data)
            this.fieldMessage(data)
            this.doCancel()
          }
          this.submitting = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doCancel() {
      this.$router.push({ name: 'pmtNOL1PerBusClsList' })
    },
    async doUpdate() {
      const apiURI = this.menu.updatePmtNL1PerBusCls
      const form = this.form
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.put(apiURI, form)
          const { data } = result
          if (data) {
            this.notify(data)
            // to go back to the list
            this.doCancel()
          }
        } catch (err) {
          const { data } = err.response.data
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.submitting = false
      }
    }
  },
  computed: {
    menu() {
      return this.$store.state.pmtNOL1PerBusClsParam.menu
    },
    busClsParam() {
      return this.$route.params.busCls
    },
    nol1Param() {
      return this.$route.params.nol1
    },
    pmtNOL1Mode() {
      return this.$route.params.pmtNOL1Mode
    },
    busClsWatch() {
      return this.form.busCls
    },
    nol1Watch() {
      return this.form.nol1
    },
    filterBusCls() {
      return this.busClsDropDownList.filter((list) => {
        return list.busCls === this.form.busCls
      })
    },
    filterNol1() {
      return this.clmNol1DropDownList.filter((list) => {
        return list.nol1 === this.form.nol1
      })
    }
  },
  watch: {
    busClsWatch(value) {
      if (value !== undefined && value.length > 0) {
        if (this.filterBusCls.length > 0) {
          this.form.busClsDesc = this.filterBusCls[0].busClsDesc
        }
      }
    },
    nol1Watch(value) {
      if (value !== undefined && value.length > 0) {
        if (this.filterNol1.length > 0) {
          this.form.nol1longDesc = this.filterNol1[0].nol1longDesc
        }
      }
    }
  },
  created() {
    this.doFetchBusClsDropDown()
    this.doFetchClmNol1DropDown()
    if (this.pmtNOL1Mode === 'New') {
      this.newMode = true
    } else {
      if (this.pmtNOL1Mode === 'Review') {
        this.reviewMode = true
      } else if (this.pmtNOL1Mode === 'Query') {
        this.queryMode = true
      }
      this.doFetchData()
    }
  },
  mounted() {},
  mixins: [MessageMixin]
}
</script>
